import React, { useState } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import { CouponTimingSlab } from '../../../../types';
import { Button, TextField } from '@mui/material';
import { addCouponTimingSlab, deleteCouponTimingSlab } from '../../../../../../stateManagement/actions/manageCouponActions';
import { useCouponAlert } from '../../../../context/CouponAlert';
import { isCouponTimingsSlabValid, validateSingleSabCouponTiming, validateSingleSlabSave } from '../RecurrenceService';
import { INVALID, INVALID_RANGE_OVERLAPPING, labelMappings } from '../../../../utils/utils';
import { openPopup } from '../../../../../../stateManagement/actions/popupActions';
import CouponConfigurableLabel from '../../../CouponConfigurableLabel';

function CouponTimingSingleSlab({ slab }: { slab: CouponTimingSlab }) {
    const {showAlert} = useCouponAlert();
    const [errors , setErrors] = useState<Record<string,string>>({});
    
    const handleSave = (id:string) => {
        const res = isCouponTimingsSlabValid(errors,slab);
        
        if(res === INVALID){
            const newErrs = validateSingleSlabSave({"et":slab["et"],"st":slab["st"]},slab);
            setErrors((pre)=>({...pre,...newErrs}));
            return;
        }

        else if(res === INVALID_RANGE_OVERLAPPING){
            openPopup("Alert", labelMappings["COUPON_TIMING_SLAB_RANGE_OVERLAPPING"])
            return;
        }

        addCouponTimingSlab({...slab,isSaved:true},id);
        showAlert(`Data 'Saved'}`,'success')
    }

    const handleDelete = (id: string) => {
        deleteCouponTimingSlab(id);
    }

    const handleUpdate = (keyName: "st" | "et", value: Dayjs) => {
        const date =value?.toDate() || null;
        const newData = {
            ...slab,
            [keyName]:date
        }
        
        addCouponTimingSlab(newData , slab.id);
        const newErrors = validateSingleSabCouponTiming({[keyName]:date},slab);
        setErrors((pre)=>({...pre,...newErrors}));
    }

    function handleNullDate(dt: Date): any {
        const x = dt?dayjs(dt):null;
        return x;
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className='coupon-timings-single-slab-wrapper'>
                <div className='coupon-timings-date-selector-wrapper'>
                    <TimePicker
                        disabled={slab?.isSaved}
                        ampm={false}
                        renderInput={(props) => <TextField {...props} sx={{padding:0}} placeholder='Start Time' {...(errors['st'] && { error: true, helperText: errors['st'] })} />}
                        label= {<CouponConfigurableLabel text='START_TIME'/>}
                        value={handleNullDate(slab.st)}
                        onChange={(value: any) => handleUpdate("st", value)}
                    />
                    <TimePicker
                        ampm={false}
                        disabled={slab?.isSaved}
                        renderInput={(props) => <TextField {...props} sx={{padding:0}} placeholder='End Time'{...(errors['et'] && { error: true, helperText: errors['et'] })}/>}
                        label= {<CouponConfigurableLabel text='END_TIME'/>}
                        value={handleNullDate(slab.et)}
                        onChange={(value: any) => handleUpdate("et", value)}
                    />
                </div>
                <div className='coupon-timings-action-btn-wrapper'>
                    {
                        slab?.isSaved ? <Button onClick={() => handleDelete(slab.id)} size='small' className='applicable-single-slab-delete-button' startIcon={<DeleteIcon />}>
                            Delete
                        </Button> : <Button variant='contained' className='applicable-single-slab-save-btn' size='small' startIcon={<DoneIcon />} onClick={()=>handleSave(slab.id)}>{'Save'}</Button>
                    }

                </div>

            </div>
        </LocalizationProvider>
    )
}

export default CouponTimingSingleSlab